import { getProperties } from "aws-amplify/storage";
import { useEffect, useState } from "react";
import displaySize from "../utils/displaySize";

const useFileMeta = (filename) => {
    const [meta, setMeta] = useState({});
    useEffect(() => {
        (async () => {
            try {
                if (filename) {
                    const result = await getProperties({ path: `public/${filename}` });
                    let fileSize = displaySize(result.size);

                    setMeta({
                        ...result,
                        fileSize,
                    });
                }
            } catch (ex) {
                console.log("failed to get file meta data", ex);
            }
        })();
    }, [filename]);

    return meta;
};

export default useFileMeta;
